import React from 'react'
import './styles.scss'

import BetaIcon from 'components/icons/BetaIcon'

/**
 * Beta mark
 * @param {object} props
 * @param {string} {props.className}
 *
 * @returns {React.Component}
 */
const BetaMark = (props) => {
  const { className = '' } = props

  return (
    <div className={`beta-container ${className}`}>
      <BetaIcon size='inherit' />
    </div>
  )
}

export default BetaMark
